import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../../shared/_utils/services/base-service';
import { PersonType } from '../entities/personType';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PersonTypeService extends BaseService {

  public uri = '/api/personType/';

  constructor(injector: Injector) {
      super(injector);
     //console.log('Instance PersonTypeService');
  }

  getPersonTypes(): Observable<PersonType[]> {
    // debugger;
    const url = this.rutaServidor + this.uri;
    return this.httpClient.get<PersonType[]> (url)
        .pipe(
            tap(response => {
             //console.log(response);
              return response;
            })
        );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/person-type.service.ts